import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["loading", "error"]
  static values = { proposalId: String }
  
  isComplete = false
  
  connect() {
    // Immediately check and update status
    this.checkStatus()
    // Only start polling if not already complete
    if (!this.isComplete) {
      this.startPolling()
    }
  }
  
  disconnect() {
    this.stopPolling()
  }
  
  startPolling() {
    this.interval = setInterval(() => {
      this.checkStatus()
    }, 2000) // Check every 2 seconds
  }
  
  stopPolling() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }
  
  async checkStatus() {
    try {
      const response = await fetch(`/proposals/${this.proposalIdValue}/status.json`)
      const data = await response.json()
      
      console.log('Proposal status:', data.status, 'syncing:', data.syncing) // Debug log
      this.updateUI(data.status, data.syncing, data.error)
      
      // Stop polling if process is complete or failed
      if ((data.status === "draft" && !data.syncing) || data.status === "sync_failed") {
        this.isComplete = true
        this.stopPolling()
        
        // Redirect immediately to edit page on success
        if (data.status === "draft" && !data.syncing) {
          window.location.href = `/proposals/${this.proposalIdValue}/edit`
        }
      }
    } catch (error) {
      console.error("Error checking status:", error)
    }
  }
  
  updateUI(status, syncing, error) {
    // Hide all states first
    this.loadingTarget.classList.add("hidden")
    this.errorTarget.classList.add("hidden")
    
    // Show appropriate state
    if (status === "creating" || syncing) {
      this.loadingTarget.classList.remove("hidden")
    } else if (status === "sync_failed") {
      this.errorTarget.classList.remove("hidden")
      if (error) {
        const errorMessage = this.errorTarget.querySelector(".text-red-700")
        if (errorMessage) {
          errorMessage.textContent = error
        }
      }
    }
    // Note: draft status will trigger immediate redirect, so no UI state needed
  }
}